// v17.19 — Traffic Control flags store (Điều tiết tải trong trận).
// Singleton: fetch 1 lần khi app load + poll 120s (+jitter 0-20s). Backend
// vẫn chặn tận gốc (204/rỗng) nên đây chỉ là lớp CẮT REQUEST từ client.
// Dùng sync `getTrafficFlag(name)` trong các vòng tick/poll hiện có.
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 120_000;

const DEFAULTS = {
  visit_tracking: true,
  visit_sampling: false,
  geoip_enrich: true,
  viewer_counter: true,
  chat_enabled: true,
  chat_eco: false,
  media_view_counter: true,
  publisher_battery: true,
  load_shed_enabled: true,
  score_realtime: true,
  ws_realtime: true,
  publisher_autostart: true,
  // v17.perf.track1 (02-2026) — kill-switch analytics (GA/PostHog). Server đặt
  // `false` → cả GA lẫn PostHog KHÔNG boot cho phiên đó (index.html read
  // `window.__PL_TF_NO_ANALYTICS__`). Mặc định `true` = tải bình thường.
  analytics: true,
};

let _flags = { ...DEFAULTS };
let _started = false;
const _subs = new Set();

// v17.perf.track1 — Publish kill-switch globals cho index.html (chạy trước
// React) tôn trọng flag mới. Truthy `analytics=false` → hai analytics boot
// script sẽ tự bail. Chỉ bật khi flag đã được thay đổi (đảm bảo state ổn định
// trước khi được đọc).
//
// LOAD-1 (early inline): index.html đọc localStorage `pl.tf.analytics` (cache
// của lần fetch trước) và set `window.__PL_TF_NO_ANALYTICS__` TRƯỚC LCP.
// LOAD-2 (React boot): trafficFlags.js fetch mới → cập nhật cache cho lần
// load kế + set kill-switch cho phiên hiện tại (nếu analytics chưa boot).
const _CACHE_KEY = "pl.tf.analytics";
function _publishAnalyticsKillSwitch() {
  try {
    if (typeof window === "undefined") return;
    const off = _flags.analytics === false;
    window.__PL_TF_NO_ANALYTICS__ = off;
    // Cache cho lần load kế — inline script đọc trước khi GA/PostHog init.
    window.localStorage.setItem(_CACHE_KEY, off ? "0" : "1");
  } catch { /* noop */ }
}

async function _fetchOnce() {
  try {
    const r = await axios.get(`${API}/api/public/traffic-flags`, { timeout: 10000 });
    const f = r?.data?.flags;
    if (f && typeof f === "object") {
      _flags = { ...DEFAULTS, ...f };
      _publishAnalyticsKillSwitch();
      _subs.forEach((cb) => { try { cb(_flags); } catch { /* noop */ } });
    }
  } catch { /* giữ flags cũ — mặc định tất cả ON */ }
}

function _ensureStarted() {
  if (_started || typeof window === "undefined") return;
  _started = true;
  _fetchOnce();
  const loop = () => {
    setTimeout(() => { _fetchOnce().finally(loop); }, POLL_MS + Math.random() * 20000);
  };
  loop();
}

export function getTrafficFlag(name, def = true) {
  _ensureStarted();
  const v = _flags[name];
  return v == null ? def : !!v;
}

export function getTrafficFlags() {
  _ensureStarted();
  return { ..._flags };
}

export function subscribeTrafficFlags(cb) {
  _ensureStarted();
  _subs.add(cb);
  return () => _subs.delete(cb);
}
